import { FC } from "react";
import {
  GlossaryFormItem
} from "Types";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GlossaryView from "Pages/Admin/OtherDetails/AdminGlossaryView";


const AdminGlossaryViewPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();

  const state = location.state || {};
  const item = (state as { item?: GlossaryFormItem }).item || null;

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="px-8 pt-6">
      <GlossaryView item={item} onCancel={handleCancel} />
    </div>
  );
};

export default AdminGlossaryViewPage;
